import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function StandardLockedIcon({
  className,
  height,
  stroke = IconColors.DarkGrey,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      fill="none"
      height={height ?? 24}
      viewBoxDimensions="0 0 24 24"
      width={width ?? 24}
    >
      <rect
        fill="none"
        height="13.5"
        rx="1.5"
        ry="1.5"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5px"
        width="16.5"
        x="3.75"
        y="9.75"
      ></rect>
      <path
        d="M6.75,9.75V6a5.25,5.25,0,0,1,10.5,0V9.75"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5px"
      ></path>
      <line
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5px"
        x1="12"
        x2="12"
        y1="15"
        y2="18"
      ></line>
    </SimpleIcon>
  );
}
